export const VERIFICATION_METHOD_TOOLTIPS = {
  HEURISTIC: {
    TITLE: 'Heuristic',
    CONTENT:
      'Indicates a component that was identified through signature-based means such as string searches, regular expression matches, and other proprietary heuristic methods.'
  },

  CRYPTOGRAPHIC_HASH: {
    TITLE: 'Cryptographic Hash',
    CONTENT: 'Indicates a component that was identified through a variety of hash-based mechanisms.'
  },

  PACKAGE_MANAGER: {
    TITLE: 'Package Manager',
    CONTENT: 'Indicates a component that was identified through parsing package manifest information.'
  },

  FUNCTION_HASHING: {
    TITLE: 'Function Hashing',
    CONTENT:
      'Components are broken down into their individual functions. These functions are hashed and then compared using machine learning to a known dataset containing billions of function hashes generated from common open source software repositories.'
  },

  SYMBOL_INDEX: {
    TITLE: 'Symbol Index (SymIndex)',
    CONTENT:
      'Uses binary analysis to extract symbol names from ELF files. These symbols are then compared using machine learning to the symbols extracted from the source code of common open source software repositories, returning likely matches.'
  },

  MACHINE_LEARNING: {
    TITLE: 'Machine Learning',
    CONTENT: 'Advanced verification using Function Hashing and Symbol Index (SymIndex) methods powered by machine learning algorithms.'
  },

  USER_MODIFIED: {
    TITLE: 'User Modified',
    CONTENT: 'The user has modified this component and thus verified via them.'
  },

  KERNEL_MODULE: {
    TITLE: 'Kernel Module',
    CONTENT: 'Indicates a component that was identified through kernel module analysis, detecting loadable kernel modules and their associated metadata.'
  },

  CURATED_HASH: {
    TITLE: 'Curated Hash',
    CONTENT: 'Indicates a component that was identified through curated hash databases, which contain verified and validated hash values for known software components.'
  },

  LEGACY_HASH: {
    TITLE: 'Legacy Hash',
    CONTENT: 'Indicates a component that was identified through legacy hash algorithms and older hash-based identification methods.'
  },

  PACKAGE_MANIFEST: {
    TITLE: 'Package Manifest',
    CONTENT: 'Indicates a component that was identified through parsing package manifest files, such as package.json, requirements.txt, or other package management metadata.'
  },

  SIGNATURE: {
    TITLE: 'Signature',
    CONTENT: 'Indicates a component that was identified through signature detection, using pattern matching against known software signatures and code patterns.'
  },

  PE_METADATA: {
    TITLE: 'PE Meta Data',
    CONTENT: 'Indicates a component that was identified through Portable Executable (PE) metadata analysis, extracting information from Windows executable file headers and sections.'
  },

  LIBRARY_VERSION: {
    TITLE: 'Library Version',
    CONTENT: 'Indicates a component that was identified through library version information, matching version strings and metadata from shared libraries and dependencies.'
  },

  LIBRARY_NAME: {
    TITLE: 'Library Name',
    CONTENT: 'Indicates a component that was identified through library name matching, comparing library names against known software component databases.'
  },

  BINARY_FINGERPRINT: {
    TITLE: 'Binary Fingerprint',
    CONTENT: 'Indicates a component that was identified through binary fingerprinting, using unique characteristics and patterns extracted from binary files to match against known components.'
  }
};

export const {
  HEURISTIC,
  CRYPTOGRAPHIC_HASH,
  PACKAGE_MANAGER,
  FUNCTION_HASHING,
  SYMBOL_INDEX,
  MACHINE_LEARNING,
  USER_MODIFIED,
  KERNEL_MODULE,
  CURATED_HASH,
  LEGACY_HASH,
  PACKAGE_MANIFEST,
  SIGNATURE,
  PE_METADATA,
  LIBRARY_VERSION,
  LIBRARY_NAME,
  BINARY_FINGERPRINT
} = VERIFICATION_METHOD_TOOLTIPS;
